import React from 'react';
import {
  Dimensions,
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import {observer} from 'mobx-react-lite';

import NoImage from '../images/LMG_IMAGE_NOT_AVAILABLE_transparent.png';
import {AppRoute} from '../models/AppRoute';
import useAppNavigation from '../navigation/useAppNavigation';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';
import {OrderLine} from '../transport/apiServiceResponse';
import {renderSticker} from '../utils/functions';

import Text from './ui-controls/Text';

type FeedProductTileCardProps = {
  product: OrderLine;
  source?: AppRoute;
};

const FeedProductTileCard = observer(({product}: FeedProductTileCardProps) => {
  const navigation = useAppNavigation();
  const {shopSelectionStore} = useStores();
  const disabled = shopSelectionStore.ecommerceDisabled;

  const handlePress = () =>
    navigation.navigate(AppRoute.PRODUCT, {
      product,
    });

  const byline =
    product?.size?.quantity > 1
      ? `${product?.size?.quantity} x ${product?.size?.size}${product?.size?.unit}`
      : `${product?.size?.size}${product?.size?.unit}`;

  //
  // SHOP NOW becomes SELECT when on dark site.
  //
  return (
    <TouchableOpacity onPress={handlePress} style={styles.container}>
      <View style={styles.imageHolder}>
        {product?.links?.medium_image ? (
          <Image
            source={{uri: product.links.medium_image}}
            style={styles.tileImage}
            resizeMode="contain"
          />
        ) : null}
        {!product.links?.medium_image && (
          <Image
            source={NoImage}
            style={styles.tileImage}
            resizeMode="contain"
            // @ts-ignore This doesn't exist in the current version of react-native
            width={127}
            height={null}
          />
        )}
        {product?.stickers.map(sticker => renderSticker(sticker))}
      </View>
      <View style={styles.textCard}>
        <Text style={styles.itemText} numberOfLines={3}>
          {product.name}
        </Text>
        <Text style={styles.itemQty}>{byline}</Text>
        <View style={styles.button}>
          <Text style={styles.buttonText}>
            {disabled ? 'SELECT' : 'SHOP NOW'}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
});

export default FeedProductTileCard;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: '#CCC',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.29,
    backgroundColor: 'white',
    shadowRadius: 4.65,
    elevation: 7,
    marginHorizontal: 8,
    marginBottom: 16,
    width: Math.ceil((Dimensions.get('screen').width - 32) / 2.5),
    maxWidth: 150,
  },
  imageHolder: {
    width: '100%',
    paddingHorizontal: 8,
  },
  tileImage: {
    width: '100%',
    aspectRatio: 1,
    marginTop: 4,
  },
  textCard: {
    width: '100%',
    paddingHorizontal: 8,
  },
  itemText: {
    fontSize: 12,
    marginTop: 4,
    marginBottom: 4,
    height: 30,
    color: theme.colour.text.heading.primary,
  },
  buttonText: {
    color: 'white',
    textAlign: 'center',
  },
  itemQty: {
    color: 'grey',
    fontSize: 10,
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    alignItems: 'center',
    borderRadius: 4,
    paddingVertical: 4,
    paddingHorizontal: 8,
    marginTop: 4,
    marginBottom: 8,
    width: '100%',
  },
});
